export default __webpack_public_path__ + "static/media/V360MANC1.2e2c02be.pdf";